interface IframeParameters {
  parameters: [string, string][];
  published: boolean;
  basePath: string;
}

const PARAMETERS = "data-parameters";

export class IFrameHTMLElement extends HTMLElement {
    
    private parameters: IframeParameters;
    constructor() {
        super();
        this.parameters = JSON.parse(this.getAttribute(PARAMETERS));
    }

    static get observedAttributes(): string[] {
        return [PARAMETERS];
    }

    private postListener = (e: MessageEvent) => {
      const data = e.data;
      if (!data) {
        return;
      }
      for (const [key, value] of this.parameters?.parameters || []) {
        if (key === data) {
          const { basePath, published } = this.parameters;
          const redirectUrl: string = `${basePath}${value}`;
          if (published) {
            window.location.replace(redirectUrl);
          } else {
            alert(redirectUrl);
          }
        }
      }
    };

    public attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
        if (name !== PARAMETERS) {
            return;
        }

        if ((!newValue && name !== PARAMETERS) || oldValue === newValue) {
            return;
        }

        if (name === PARAMETERS) {
            const parameters: IframeParameters = JSON.parse(newValue);
            this.parameters = parameters;
            if (parameters.parameters?.length) {
              window.removeEventListener('message', this.postListener, false);
              window.addEventListener('message', this.postListener, false);
            }
        }
    }

    public disconnectedCallback(): void {
      window.removeEventListener('message', this.postListener, false);
    }
}
